// Staging serves the exact same bundle as prod — the hostname is the only
// tell. Testers on staging must never be bounced to the prod marketing
// site: every "leave for plaintosee.cc" exit becomes "start fresh, here"
// (the finish handlers clear the resume state first, so "/" lands on a
// clean start). Preview (Rich-gated, prod-backed) deliberately keeps prod
// behavior — it exists to rehearse exactly what prod will do.

export function isStagingHost(
  hostname: string | undefined = typeof window !== "undefined"
    ? window.location.hostname
    : undefined,
): boolean {
  return (hostname ?? "").startsWith("staging-");
}

/** Where a "done / leave" exit goes: the marketing site on prod, the app's
 *  own clean start on staging. */
export function finishHref(): string {
  return isStagingHost() ? "/" : "https://plaintosee.cc";
}

/** Where the wizard-mast brand link goes (plain navigation, keeps resume
 *  state): marketing home on prod, the app root on staging. */
export function brandHomeHref(): string {
  return isStagingHost() ? "/" : "https://plaintosee.cc";
}
